(() => {
  'use strict';
  const dictionary = window.StableDaysSpanish;
  if (!dictionary) return;
  const preferenceKey = 'stabledays:language:v1';
  const allowed = value => value === 'en' || value === 'es';
  let preference = null;
  try { preference = localStorage.getItem(preferenceKey); } catch {}
  if (!allowed(preference)) {
    try { preference = decodeURIComponent((document.cookie.match(/(?:^|;\s*)sd_language=([^;]*)/) || [])[1] || ''); } catch {}
  }
  const browserLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || 'en';
  let language = allowed(preference) ? preference : (/^es(?:-|$)/i.test(browserLanguage) ? 'es' : 'en');
  const originals = new WeakMap();
  const attributes = new WeakMap();
  const skip = 'script,style,noscript,textarea,input,option,vturb-smartplayer,[data-no-translate]';
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const translate = value => {
    if (language !== 'es') return value;
    const key = normalize(value);
    let translated = dictionary[key];
    if (!translated && key.startsWith('Like comment by ')) translated = 'Me gusta el comentario de ' + key.slice(16);
    if (!translated && /^(From |Subtotal: |Balance: |Back to )/.test(key)) { const prefix = key.match(/^(From |Subtotal: |Balance: |Back to )/)[0]; translated = (dictionary[prefix.trim()] || prefix.trim()) + ' ' + key.slice(prefix.length); }
    if (!translated && /^Cart \(\d+\)$/.test(key)) translated = key.replace('Cart', 'Carrito');
    if (!translated) return value;
    return (value.match(/^\s*/) || [''])[0] + translated + (value.match(/\s*$/) || [''])[0];
  };
  function textNode(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    let record = originals.get(node);
    if (!record || (node.nodeValue !== record.last && node.nodeValue !== record.source)) {
      record = {source:node.nodeValue,last:node.nodeValue};
      originals.set(node,record);
    }
    const value = translate(record.source);
    record.last = value;
    if (node.nodeValue !== value) node.nodeValue = value;
  }
  function apply() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) textNode(node);
    for (const element of document.querySelectorAll('[aria-label],[alt],[placeholder],[title]')) {
      if (element.closest('vturb-smartplayer,[data-no-translate]')) continue;
      let records = attributes.get(element);
      if (!records) { records = {}; attributes.set(element,records); }
      for (const name of ['aria-label','alt','placeholder','title']) {
        if (!element.hasAttribute(name)) continue;
        const current = element.getAttribute(name);
        let record = records[name];
        if (!record || (current !== record.last && current !== record.source)) record = records[name] = {source:current,last:current};
        record.last = translate(record.source);
        if (current !== record.last) element.setAttribute(name, record.last);
      }
    }
  }
  const initialTitle = document.title;
  const selector = document.getElementById('site-language');
  function refresh() {
    document.documentElement.lang = language;
    if (selector) selector.value = language;
    document.title = initialTitle.split(' | ').map(translate).join(' | ');
    apply();
  }
  if (selector) selector.addEventListener('change', () => {
    if (!allowed(selector.value)) return;
    language = selector.value;
    try { localStorage.setItem(preferenceKey, language); } catch {}
    // A small preference cookie also keeps the selection when localStorage is unavailable.
    try { document.cookie = 'sd_language=' + language + '; Path=/; Max-Age=31536000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch {}
    refresh();
  });
  refresh();
  let pending = false;
  new MutationObserver(mutations => {
    if (pending || !mutations.some(m => {
      const element = m.target.nodeType === Node.ELEMENT_NODE ? m.target : m.target.parentElement;
      return element && !element.closest(skip);
    })) return;
    pending = true;
    queueMicrotask(() => {pending = false; apply();});
  }).observe(document.body, {childList:true,subtree:true,characterData:true});
})();
